// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"ba38100e","239":"cafd29b4","453":"51b20bab","732":"7629cf6b"}[chunkId] + ".chunk.js";
};